module.exports = __webpack_public_path__ + "ProximaNova-Light.8ed993d938709df0f271183645b6d30e.woff2";